import { TextField, Pagination, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import DeleteConfirm from "../DeleteConfirm/index";
import axios from "axios";
import upload from "./upload.png";

import Box from "./Box";
import "./style.css";

export default function AllMofa({ setChooseBox }) {
  const [deleteConfirm, setDeleteConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [edit, setEdit] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(10); // you can change later
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");


  const handleDelete = async () => {
    try {
      setLoading(true);
      setDeleteConfirm("");
      const response = await axios.delete(process.env.REACT_APP_BACKEND + "/mofa/delete/" + deleteConfirm);
      console.log(response);
      setData((prev) => prev?.filter((item) => item._id !== deleteConfirm));
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    if (!selectedFile) {
      setError("Please select a file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("fileName", edit.name);

    try {
      setLoading(true);
      await axios.put(process.env.REACT_APP_BACKEND + "/mofa/update", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setSuccess("File uploaded successfully.");
      setEdit(null);
    } catch (err) {
      console.log(err);
      setError(err.response.data || "Error uploading file.");
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    setError("");
    setSuccess("");
  };

  const handleVisibility = async (id, status) => {
    try {
      setLoading(true);
      await axios.put(process.env.REACT_APP_BACKEND + "/mofa/update-visibility/" + id, { status });
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND}/mofa/all`,
        {
          params: {
            page,
            limit,
            search,
          },
        }
      );

      setData(response.data.data);
      setTotalPages(response.data.pagination.totalPages);

    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    !edit &&
      (async function () {
        try {
          setLoading(true);
          const response = await axios.get(
            `${process.env.REACT_APP_BACKEND}/mofa/all`,
            {
              params: {
                page,
                limit,
                search,
              },
            }
          );

          setData(response.data.data);
          setTotalPages(response.data.pagination.totalPages);

        } catch (error) {
          console.log({ error });
        } finally {
          setLoading(false);
        }
      })();
  }, [edit, page, search]);

  useEffect(() => {
    console.log(searchInput)
  const timeout = setTimeout(() => {
    setSearch(searchInput);
    setPage(1);
  }, 500); // debounce delay (ms)

  return () => clearTimeout(timeout);
}, [searchInput]);



  if (loading)
    return (
      <div className="loader-main">
        <div className="loading" />
      </div>
    );
  return (
    <>
      {deleteConfirm && <DeleteConfirm onCancel={() => setDeleteConfirm("")} onConfirm={handleDelete} />}

      {edit && (
        <div className="edit-form">
          <form onSubmit={handleEdit}>
            <h1>Update PDF</h1>
            <label htmlFor="upload-hidden">
              <div className="upload-box">
                {selectedFile ? (
                  <h1>Selected</h1>
                ) : (
                  <>
                    <img src={upload} alt="not found" />
                    <h1 className="select">Please Select a file</h1>
                  </>
                )}
              </div>
            </label>
            <input id="upload-hidden" hidden type="file" accept="application/pdf" onChange={handleFileChange} required />

            <div className="input-main">
              <label>Name:</label>
              <input type={"text"} value={edit.name} />
            </div>
            <button type="submit">Save</button>
            <button onClick={() => setEdit(null)}>Cancel</button>
          </form>
        </div>
      )}


      <Stack spacing={2} sx={{ pt:5,mx:"auto",width:"300px"}}>
        <TextField
          label="Search by name"
          variant="outlined"
          size="medium"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
        />
      </Stack>
      <div className="all-apostille-main">
        {data?.map((item, i) => (
          <Box key={i} {...item} onDelete={(id) => setDeleteConfirm(id)} onEdit={setEdit} onVisibilityChange={handleVisibility} />
        ))}
      </div>

      <Stack spacing={2} alignItems="center" sx={{ my: 4 }}>
        <Pagination
          count={totalPages}
          page={page}
          onChange={(e, value) => setPage(value)}
          color="primary"
          shape="rounded"
          size="large"

        />
      </Stack>



      <div className="btn-container">
        <button className="done-button" onClick={() => setChooseBox("")}>
          Done
        </button>
      </div>
    </>
  );
}
